var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiGenerateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7072_8858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93652 17.755C6.6353 16.8192 7.54298 16.0594 8.58727 15.5364C9.63155 15.0133 10.7836 14.7414 11.9515 14.7422C13.7044 14.7422 15.3158 15.3422 16.593 16.3493",
    stroke: "#4D569A",
    strokeWidth: 2.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8772 22.7762H3.37723C2.80891 22.7762 2.26387 22.5505 1.862 22.1486C1.46014 21.7467 1.23438 21.2017 1.23438 20.6334V3.49051C1.23438 2.92219 1.46014 2.37715 1.862 1.97528C2.26387 1.57342 2.80891 1.34766 3.37723 1.34766H20.5201C21.0884 1.34766 21.6335 1.57342 22.0353 1.97528C22.4372 2.37715 22.6629 2.92219 22.6629 3.49051V9.91909",
    stroke: "#4D569A",
    strokeWidth: 2.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9487 11.5262C12.3708 11.5262 12.7887 11.4431 13.1787 11.2816C13.5687 11.12 13.923 10.8833 14.2215 10.5848C14.52 10.2863 14.7567 9.93197 14.9183 9.542C15.0798 9.15202 15.1629 8.73405 15.1629 8.31194C15.1629 7.88984 15.0798 7.47186 14.9183 7.08189C14.7567 6.69191 14.52 6.33757 14.2215 6.0391C13.923 5.74062 13.5687 5.50386 13.1787 5.34233C12.7887 5.1808 12.3708 5.09766 11.9487 5.09766C11.0962 5.09766 10.2786 5.4363 9.67582 6.0391C9.07302 6.64189 8.73438 7.45946 8.73438 8.31194C8.73438 9.16442 9.07302 9.98199 9.67582 10.5848C10.2786 11.1876 11.0962 11.5262 11.9487 11.5262ZM15.7287 22.6348C14.9765 22.5041 14.9765 21.4241 15.7287 21.2934C17.06 21.0605 18.2919 20.437 19.268 19.5022C20.244 18.5674 20.92 17.3634 21.2101 16.0434L21.2551 15.8355C21.4179 15.0919 22.4765 15.0877 22.6458 15.8291L22.7015 16.0712C23.0008 17.3861 23.6824 18.5831 24.6604 19.5116C25.6384 20.4401 26.8693 21.0585 28.1979 21.2891C28.9544 21.4219 28.9544 22.5062 28.1979 22.6391C26.8693 22.8697 25.6384 23.4881 24.6604 24.4166C23.6824 25.345 23.0008 26.542 22.7015 27.8569L22.6458 28.0991C22.4765 28.8405 21.4179 28.8362 21.2551 28.0927L21.2101 27.8848C20.92 26.5648 20.244 25.3608 19.268 24.426C18.2919 23.4911 17.06 22.8677 15.7287 22.6348Z",
    stroke: "#4D569A",
    strokeWidth: 2.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7072_8858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerateIcon);
export default __webpack_public_path__ + "static/media/AiGenerateIcon.19bc997f199694abf15b1deaff391fb9.svg";
export { ForwardRef as ReactComponent };